import Route from "@ember/routing/route"
import { inject as service } from "@ember/service"

export default class ActionRoute extends Route {
  @service("ember-store")
  store

  @service
  session

  model(params) {
    return this.store.find("action", params.action_id)
  }

  afterModel() {
    // Ember.run.later(() => {
    //   if (window.Prism){
    //     window.Prism.highlightAll()
    //   }
    // }, 250)
  }
}
